import React, { createContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';

/**
 * @param {string} s
 * @returns {import(".").TokenString}
 */
const s2Token = (s) => /** @type {import(".").TokenString} */ (s);

const _jsxFileName = "/Users/seabrookstudios/projects/seabrook-studios/packages/@seabrookstudios/auth/src/CachedTokenContext.jsx";
/**
 * @type {import(".").TokenString}
 */
const initialToken = s2Token('');

const CachedTokenContext = createContext(initialToken);

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @param {() => import('react').ReactNode} [props.LoadingScreen]
 * @param {() => import('@tanstack/react-query').UseQueryResult<import('.').TokenString|null,Error>} props.useCachedCredentials
 */
const CachedTokenProvider = ({ children, LoadingScreen, useCachedCredentials }) => {
  const { data: credentials = initialToken, isLoading } = useCachedCredentials();

  if ((isLoading || !credentials) && LoadingScreen) {
    return React.createElement(LoadingScreen, {__self: undefined, __source: {fileName: _jsxFileName, lineNumber: 21}} );
  }

  return (
    React.createElement(CachedTokenContext.Provider, { value: credentials || initialToken, __self: undefined, __source: {fileName: _jsxFileName, lineNumber: 25}}
      , children
    )
  );
};

const HasCreds = ['has-creds'];
const Token = ['token'];
const Credentials = ['credentials'];

const useInvalidateCredentials = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: HasCreds });
    queryClient.invalidateQueries({ queryKey: Token });
    queryClient.invalidateQueries({ queryKey: Credentials });
  };
};

const useInvalidationWrapper = () => {
  const invalidateCreds = useInvalidateCredentials();

  /**
   * @param {function} func
   */
  const wrapper = async (func) => {
    try {
      const response = await func();
      return response;
    } catch (e) {
      console.log(e.message);
      if (e.message === 'UNAUTHORISED') {
        invalidateCreds();
      }

      throw e;
    }
  };

  return wrapper;
};

/**
 * @param {import(".").TokenString} token
 * @returns
 */
const optionsAuth = (token) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  };
};

export { CachedTokenContext, CachedTokenProvider, Credentials, HasCreds, Token, optionsAuth, s2Token, useInvalidateCredentials, useInvalidationWrapper };
